import React, { useState } from "react";
import Sidebar from "../components/Sidebar";
import { Outlet } from "react-router-dom";

function LayoutSplash({ autusuario, permisos }) {
  const [sidebarKey, setSidebarKey] = useState(0);

  const handleModuloSave = () => {
    setSidebarKey(prev => prev + 1); // Forzar re-render del Sidebar
  };

  return (
    <div className="flex flex-row h-screen">
      <Sidebar key={sidebarKey} autusuario={autusuario} permisos={permisos} />
      <div className="w-full">
        {/* Aquí Outlet contiene las rutas, y ahí dentro debes pasar handleModuloSave a donde uses ModalModulo */}
        <Outlet context={{ handleModuloSave }} />
      </div>
    </div>
  );
}

export default LayoutSplash;
